import React, { Component } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../../../common/handleKeyPress';
import Icons from './SurveyIcons';

const optionTypes = {
    Emoji: 'SOCIAL_REACTION_EMOJI',
    Like: 'SOCIAL_REACTION_LIKE',
    Stars: 'PULSE_RANGE_STARS',
    'Face range': 'PULSE_RANGE_FACES',
    Numbers: 'PULSE_RANGE_NUMBERS',
    eNPS: 'ENPS',
    Checkboxes: 'PULSE_BINARY_CHECKBOX_CONFIRM',
    Thumbs: 'PULSE_BINARY_THUMBS_UP_AND_DOWN',
    'Yes/No': 'PULSE_BINARY_YES_AND_NO',
};

// Grabs key (ie 'Emoji') based on value (ie 'SOCIAL_RANGE_EMOJI')
const getSurveyName = (survey) => Object.keys(optionTypes).filter((key) => optionTypes[key] === survey)[0];

export default class SurveyOptions extends Component {
    state = {
        selected: 'Emoji',
    };

    componentDidMount() {
        const { selectedSurvey } = this.props;
        this.setState({ selected: getSurveyName(selectedSurvey) });
    }

    componentDidUpdate(prevProps) {
        const { selectedSurvey } = prevProps;
        const { selectedSurvey: newSelectedSurvey } = this.props;

        // when the user clicks on another survey element, we need to load the selected survey again in order to refresh the UI
        if (selectedSurvey !== newSelectedSurvey) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ selected: getSurveyName(newSelectedSurvey) });
        }
    }

    renderOptions = (options) => {
        const { selected } = this.state;

        const onSurveyClick = (option) => {
            const { onClick } = this.props;

            this.setState({ selected: option });
            onClick(optionTypes[option]);
        };

        return options.map((option) => (
            <div
                key={`${option}-key`}
                style={{
                    backgroundColor: selected === option ? '#f3f8fc' : 'white',
                    border: selected === option ? '1px solid #0277bd' : '1px solid white', // setting the false return to none or 0 makes sizing jump a bit
                    borderRadius: 3,
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: 5,
                    height: 28,
                    width: 180,
                    marginBottom: 10,
                    cursor: 'pointer',
                }}
                onClick={() => onSurveyClick(option)}
                onKeyDown={(e) => handleKeyPress(e, () => onSurveyClick(option))}
                tabIndex={0}
                role="button"
                aria-label={`Use ${option} survey option`}
            >
                <Icons type={option} fill={selected === option ? '#0277bd' : '#727273'} />
                <div style={{ color: '#1c1c1c', fontSize: 12, marginRight: 20 }}>{option}</div>
            </div>
        ));
    };

    render() {
        const { group } = this.props;
        const reactions = ['Emoji', 'Like'];
        const range = ['Stars', 'Face range', 'Numbers', 'eNPS'];
        const binary = ['Checkboxes', 'Thumbs', 'Yes/No'];
        switch (group) {
            case 'reaction':
                return this.renderOptions(reactions);
            case 'range':
                return this.renderOptions(range);
            case 'binary':
                return this.renderOptions(binary);
            default:
                return null;
        }
    }
}

SurveyOptions.propTypes = {
    selectedSurvey: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    group: PropTypes.string.isRequired,
};
